import { css } from '@emotion/react'
import { Text, Theme, useTheme, VFlow } from 'bold-ui'

interface CriteriosVulnerabilidadeFamiliarListProps {
  titulo: string
  criterios: ReadonlyArray<string>
}

export function CriteriosVulnerabilidadeFamiliarList(props: Readonly<CriteriosVulnerabilidadeFamiliarListProps>) {
  const { titulo, criterios } = props
  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <VFlow vSpacing={0} style={styles.tabela}>
      <div css={styles.titulo}>
        <Text fontWeight='bold'>{titulo}</Text>
      </div>
      <div css={styles.conteudo}>
        <ul css={styles.lista}>
          {criterios.map((criterio) => (
            <li key={criterio} css={styles.item}>
              <Text>{criterio}</Text>
            </li>
          ))}
        </ul>
      </div>
    </VFlow>
  )
}

const createStyles = (theme: Theme) => ({
  tabela: css`
    min-width: 20rem;
    border: 1px solid ${theme.pallete.divider};
    border-radius: 2px;
  `,
  titulo: css`
    padding: 0.5rem 1rem;
    border-bottom: 1px solid ${theme.pallete.divider};
    background-color: ${theme.pallete.gray.c90};
  `,
  conteudo: css`
    padding: 0.75rem 1rem;
  `,
  lista: css`
    margin: 0;
    padding-left: 1.25rem;
    list-style-type: disc;
    &:has(li:nth-child(15)) {
      column-count: 2;
      column-gap: 2rem;
    }
    &:has(li:nth-child(29)) {
      column-count: 3;
    }
  `,
  item: css`
    margin-bottom: 0.25rem;
    &:nth-child(14n) {
      break-after: column;
    }
    &::marker {
      color: ${theme.pallete.text.main};
    }
  `,
})
